var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/social/Facebook"),React.createElement("g",{"id":"icons/social/Facebook","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("path",{"d":"M27.5476413,19.9653293 L22.7425566,19.9653293 L22.7425566,38 L15.4624452,38 L15.4624452,19.9653293 L12,19.9653293 L12,13.6272284 L15.4624452,13.6272284 L15.4624452,9.52575714 C15.4624452,6.59276259 16.8223658,2 22.8073604,2 L28.2,2.02311381 L28.2,8.17532068 L24.2872881,8.17532068 C23.6454901,8.17532068 22.7430366,8.50383181 22.7430366,9.9029548 L22.7430366,13.6331298 L28.183679,13.6331298 L27.5476413,19.9653293 Z","id":"Path","stroke":"#5B00DB","strokeWidth":"2"}))]);
}

Facebook.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;
